module.exports = __webpack_public_path__ + "media/components/footer/static/tide__white-cb6c6161b45a076dd9f6e528084e46a1.svg";